import type { FC } from 'react';
import type { RangeFacetProps } from './FacetValue.types';

// TODO: Implement Range facets when needed.
const RangeFacet: FC<RangeFacetProps> = () => null;

RangeFacet.displayName = 'ElemasonSearchFacetFormRangeFacet';

export { RangeFacet };
